import React from 'react';
import { useState} from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import './mylogin.css'
import SearchBar from '../searchbar/searchbar';
import MyMap from '../mymap/mymap';
import { AppContext } from '../../App';
import loginPic from './loginpic.jpg';
import mobileLoginPic from './mobileloginpic.jpg';
import tripPlannerLogo from './tripplannerlogin.PNG';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function MLogin() {
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [loginFailed, setLoginFailed] = useState(false);
    const { userCtx, setUserCtx } = React.useContext(AppContext);
    const navigate = useNavigate();

const handleSubmit = async (event) =>{
    event.preventDefault();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({name,password}),
        credentials: 'include', // Include cookies
    };
    const response = await fetch(`${BACKEND_URL}/login`, requestOptions);
    const data = response.json().then ((res)=> {
        if ((res==null) || (res == 'NA')) {
            setLoginFailed(true);
            setUserCtx(null); // Clear user context on login failure
            console.log("Login failed");
        }   else {
            setLoginFailed(false);
            setUserCtx(res); // Set user context on successful login
            navigate("/userTrips"); // Redirect to the desired page after successful login
        } 
    
    });
 //   console.log(data);
}

    const isMobile = window.innerWidth <= 600;
    const backgroundImage = isMobile ? mobileLoginPic : loginPic;
    
    return  (
                <div style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: isMobile ? 'cover' : '100vw 100vh',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    backgroundColor: '#f0f0f0',
                    minHeight: '100vh',
                    width: '100vw',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'auto'
                }}>
                {/* App Title */}
                <img src={tripPlannerLogo} alt="Trip Planner" className="app-title" />
                <form className="login-form" onSubmit={handleSubmit}>
                    <input 
                        id="username" 
                        type="text" 
                        placeholder="User Name"
                        value={name} 
                        onChange={(e)=>{
                            setName(e.target.value);
                            if(loginFailed) setLoginFailed(false); // Hide error when user starts typing
                        }} 
                    />
                    <input 
                        id="password" 
                        type="password" 
                        placeholder="Password"
                        value={password} 
                        onChange={(e)=>{
                            setPassword(e.target.value);
                            if(loginFailed) setLoginFailed(false); // Hide error when user starts typing
                        }} 
                    />
                    <input type="submit" value="Login" />
                </form>
                <div className="login-register-link-container">
                    <p className="login-register-link">
                        Don't have an account? <Link to="/register">Register here</Link>
                    </p>
                </div>
                <label id="loginFailLabel" className={`login-failed-label${loginFailed ? ' visible' : ''}`}>Login Failed</label>
                </div>
                
        
                
            );
}
